export default __webpack_public_path__ + "a65c51e8da240b5a3cfa9eb7236ecf88.svg";